import { useEffect, useMemo, useState } from 'react';
import type { JSX } from 'react';

import { useLocation } from 'react-router';

import { useCurrentRouteConfig } from 'src/app/routes';

function SsrWarningBannerInner() {
	const location = useLocation();
	const [hasLocationChanged, setHasLocationChanged] = useState<boolean | undefined>(undefined);

	// we should not display the banner after navigating to another route
	// eslint-disable-next-line react-hooks/set-state-in-effect
	useEffect(() => setHasLocationChanged((prevValue) => prevValue !== undefined), [location]);

	const routeConfig = useCurrentRouteConfig();
	// checking if the current route has SSR enabled
	const ssrRoute = useMemo(() => routeConfig?.config.ssr && routeConfig.config.ssr.enabled, [routeConfig]);

	if (hasLocationChanged || !ssrRoute) return null;

	return (
		<div className="pointer-events-none fixed left-0 top-0 z-[1000000] box-border w-screen bg-fill-brand-strong text-center text-base leading-6 text-white opacity-75">
			⚠️ This SSR page is currently accessed in CSR mode ⚠️
		</div>
	);
}

export function SsrWarningBanner({ ssr }: { ssr: boolean }): JSX.Element | null {
	if (ssr || process.env.NODE_ENV !== 'development') return null;

	// using an inner component to avoid doing route filtering in non-dev env
	return <SsrWarningBannerInner />;
}
